import { createApp } from 'vue'
import ArcoVue from '@arco-design/web-vue';
import App from './App.vue'
import router from './router'
import store from './store'
import '@arco-design/web-vue/dist/arco.css';
// import 'lib-flexible'
import '@/assets/js/rem.js'
import axios from 'axios';
import API from './require/api';

const app = createApp(App);
app.config.globalProperties.$API = API;
app.config.globalProperties.baseUrl = '/api';
app.use(ArcoVue);
app.use(store);
app.use(router);
app.mount('#app');
